import styled from "styled-components";
import React, { useEffect, useState } from "react";
import { PodSettings } from "../../assets/Podcast/PodSettings";
import { PodAnalytics } from "../../assets/Podcast/PodAnalytics";
import { PodFolder } from "../../assets/Podcast/PodFolder";
import { TextBtn } from "../../components/inputs/TextBtn";
import { gql, useApolloClient, useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { LoadingWLogo } from "../../components/LoadingWLogo";

const StyleCss = styled.div`
  .content {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding: 1rem;
    font-size: 1rem;
    text-align: justify;
    .title-center {
      font-size: 1.5rem;
      font-weight: 600;
      text-align: center;
    }
    .title-item {
      font-weight: 700;
      margin-top: 1rem;
      &.blue {
        color: blue;
      }
    }
    .bold-client {
      font-weight: 700;
      color: green;
      text-decoration: underline;
    }
    .bold-program {
      font-weight: 600;
      text-decoration: underline;
      color: blue;
    }
    .bold-comp {
      font-weight: 700;
      text-decoration: underline;
      color: var(--primary-1);
    }
    .form {
      display: flex;
      gap: 0.5rem;
      align-items: center;
      flex-wrap: wrap;
      margin: 1rem 0;
      input {
        padding: 0.5rem;
        margin: 0 1rem 0 0;
      }
    }
    .container {
      width: 100%;
      display: grid;
      grid-template-columns: repeat(12, calc(calc(100% / 12) - calc(110px / 12)));
      grid-gap: 10px;
      border-top: 1px solid var(--n-grey-3);
      .action {
        padding: 1rem 0;
      }
    }
    .errors {
      display: flex;
      flex-direction: column;
      gap: 0.5rem
    }
  }
`;
// get data
export const Compliance_Query = gql`
  query ComplianceQuery{
    getCompliance{
      _id
      User
      Name
      WorkID
      Date
      Time
    }
  }
`;

const EditCompliance_Mutation = gql`
  mutation EditCompliance(
    $_id: ID,
    $Name: String,
    $WorkID: String,
  ) {
    editCompliance(
      _id: $_id
      Name: $Name
      WorkID: $WorkID
    ) {
      status
    }
  }
`;



function WorkPageCompliance(props) {
  const client = useApolloClient()

  const [states, setStates] = useState({});
  const [error, setError] = useState({});

  const [complianceFunc, complianceData] = useLazyQuery(Compliance_Query, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      if(data.getCompliance){
        setStates(data.getCompliance)
      }
    }
  });
  const [CDataQuery, { loading }] = useMutation(
    EditCompliance_Mutation,
    {
      onCompleted: (data) => {
        if(data.editCompliance){
          complianceFunc();
          // setStates(data.editCompliance)
        }
      }
    }
  );
  useEffect(() => {
    complianceFunc();
  }, []);
  const onChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    setStates(prev => {
      let temp = {...prev}
      temp[name] = value;
      return temp;
    })
  }
  const sendData = () => {
    let variable = {};
    if(states._id){
      variable._id = states._id
    }
    let errors = {}
    if(!states.Name){
      errors.Name = "Full name must be filled"
    } else {
      variable.Name = states.Name
    }
    if(!states.WorkID){
      errors.WorkID = "Work ID must be filled"
    } else {
      variable.WorkID = states.WorkID
    }
    if(Object.keys(errors).length){
      setError(errors)
      return;
    }
    CDataQuery({
      variables: variable
    })
  }
  
  return (
    <StyleCss className="main-box">
      <div className="title-bar">
          <div className="title">
            <div className="icon"><PodFolder/></div>
            <div className="text">Compliance</div>
          </div>
      </div>
      <div className="content">
        <div className="title-center">
          Compliance & IS Commitment Signing
        </div>

        <div className="title-item">Preamble</div>
        <p>As <span className="bold-comp">Faraz Andishan Hesab</span> employee <span className="bold-program">working for the program</span> of <span className="bold-client">Client</span> , by signing this Compliance Commitment document, I admit and agree to following:</p>
        <p>I am fully aware that, tackling uncertainties of business is guaranteed by compliance to applicable laws and regulations including international and national laws and regulations where the business operates. This is why I shall not overstep the boundaries of law. Meanwhile as I acknowledge that violating any applicable laws and regulations may have detriment effect on <span className="bold-client">Client</span>, I commit that I will take legal compliance requirements as my working bottom line.</p>
        <p>I also admit that <span className="bold-client">Client</span> has organized regular training, publicity, awareness-raising programs and examinations regarding different aspects of compliance including but not limited to trade compliance, financial compliance, Anti-bribery compliance, information and cyber security and privacy protection, and I shall continue to attend these trainings and pass the examinations to improve my compliance awareness and ability.</p>
        <p>Considering above, I specifically declare that:</p>
        
        <div className="title-item blue">General Commitment</div>
        <p>I shall fully comply with all applicable external legal requirements including but not limited to international laws and regulations, national laws of Iran and specific requirements of customers as well as compliance management regulations and policies of <span className="bold-client">Client</span> regarding trade compliance, financial compliance, Anti-bribery compliance, information and cyber security and privacy protection.</p>
        
        <div className="title-item blue">Trade Compliance</div>
        <p>I acknowledge that I am neither a U.S. national nor a U.S. permanent resident card/green card/passport holder, nor am I on any applicable legal sanctions list maintained by such as the U.S., EU, and United Nations, etc.</p>
        <p>I undertake that before conducting any business, I shall consider conformity of products, destination, end use, and end-users with applicable trade compliance laws and I will successfully pass required internal review processes.</p>
        
        <div className="title-item blue">Financial Compliance</div>
        <p>I pledge that in any business related to <span className="bold-client">Client</span>, I shall not use the U.S. dollar for settlement and shall not violate any applicable sanction program. I will truthfully disclose to the compliance reviewer true information about the transaction entity (including but not limited to the end customer, partner, and supplier). Besides, I pledge that payment and receiving any amount shall be based on a contract and payment and receipt shall match with corresponding contract from all the aspects.</p>

        <div className="title-item blue">Anti-Commercial Bribery Compliance</div>
        <p>I understand and fully comply with all applicable external legal requirements and <span className="bold-client">Client</span> policies, including but not limited to international conventions and standards, local laws (Iranian criminal law), internal regulations, and customers' specific requirements on anti-bribery and corruption. </p>
        <p>I have received adequate training and awareness on anti-bribery, related internal and external requirements, and prohibitions on bribery and corruption. If I am accused or convicted of offering or accepting bribes, I will be fully personally liable.</p>
        <div className="title-item blue">Cyber Security and Privacy Protection</div>
        <p>I commit that without consent of customers, suppliers and end-users, I shall not touch their network data, personal data, or snoop on their privacy. In this regard, I commit that I shall follow the defined necessary procedures to obtain consent and access the network and personal data. And I shall take utmost care to protect information obtained in this way. I guarantee that I will use authorized data only for activities within the scope of authorization.</p>
        <div className="title-item blue">Information Security</div>
        <p>I accept to strictly guard the <span className="bold-client">Client</span>'s physical assets which is given to me as trust. Besides I strongly agree that without permission, I will not disclose the <span className="bold-client">Client</span>'s information to the outside of <span className="bold-client">Client</span> through hard copy, social networks, instant messaging services and apps, copying on external media, writing on CD/DVD or any other possible method.</p>
        <div className="title-item blue">Miscellaneous</div>
        <p>I commit that in case of doubt or any question regarding any compliance issue, before taking any action I shall consult with <span className="bold-client">Client</span>’s appointed compliance team.</p>
        <p>I pledge that if I violate any of the applicable laws or management regulations or policies of <span className="bold-client">Client</span>, <span className="bold-client">Client</span> has right to take punitive measure stipulated under relevant documents or take legal action against me. Besides, I agree to indemnify and hold <span className="bold-client">Client</span> harmless if there is a legal proceeding against <span className="bold-client">Client</span> due to my negligence or fault in respecting laws or regulations.</p>
        <div className="form">
          Committed by: 
            <input
              type="text"
              name="Name"
              placeholder="Full Name"
              value={(states.Name) ? states.Name : ""}
              onChange={onChange}
            /> 
          Work ID: 
            <input 
              type="text"
              placeholder="Work ID"
              name="WorkID"
              value={(states.WorkID) ? states.WorkID : ""}
              onChange={onChange}
            /> 
          Date: 
            <input
              disabled
              type="text"
              name="Date"
              value={(states.Date) ? states.Date : ""}
            />
        </div>
        <div className="errors">
          <div>{error.Name ? error.Name : ""}</div>
          <div>{error.WorkID ? error.WorkID : ""}</div>
        </div>
        <div className="errors">
          {
            (states._id) ? (
              <div className="title-item blue">Your compliance has been recorded.</div>
            ) : ""
          }
        </div>
        <div className="container">
          <div className="action" style={{ gridColumn: "9 / 13" }}>
            <TextBtn
                text={"Submit Compliance"}
                type={"submit"}
                onclick={sendData}
                loading={loading || complianceData.loading}
                disabled={loading || complianceData.loading}
            />
          </div>
        </div>
      </div>
    </StyleCss>
  )
}
export default WorkPageCompliance;